import { NgModule } from '@angular/core';
// import { CiptechServicesModule } from '../services/services.module';
import { AuthenticatedGuard } from './authenticated.guard';
import { CartFlowGuard } from './cart-flow.guard';
import { ClientsGuard } from './clients.guard';
import { RolGuard } from './rol.guard';

@NgModule({
	imports: [
		// CiptechServicesModule
	],
	providers: [
		AuthenticatedGuard,
		CartFlowGuard,
		RolGuard,
		ClientsGuard
	]
})
export class CiptechGuardsModule { }
